import { css } from "styled-components";
import { ExpiredMessageStyled, SessionExpiredMessage } from "./SessionExpired.js";

export const BukkuMessage = {
    SessionExpiredMessage,
};

export const BukkuMessageStyled = css`
    ${ExpiredMessageStyled}
`;
